export enum BoostType {
  PREMIUM = "premium",
  FEATURED = "featured",
  NORMAL = "normal",
}

// ONLY FOR BACKEND
export enum ListingType {
  BUY = "buy",
  RENT = "rent",
  UNKOWN = "unknown",
}

export enum PropertyFurnishingType {
  FURNISHED = "furnished",
  UNFURNISHED = "unfurnished",
  PARTLY_FURNISHED = "partly-furnished",
}

export enum PropertyTourType {
  FULL_360 = "360",
  VIDEO = "video",
}

export enum PropertyRentalPeriodType {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export enum PropertyListingType {
  RENT = "rent",
  BUY = "buy",
  COMMERCIAL_BUY = "commercial-buy", // commercial buy and rent is for the frontend only
  COMMERCIAL_RENT = "commercial-rent",
  OFF_PLAN = "off-plan",
}

export enum PropertyPurposeType {
  RESIDENTIAL = "residential",
  COMMERCIAL = "commercial",
}

export enum PropertyType {
  TOWNHOUSE = "townhouse",
  VILLA = "villa",
  APARTMENT = "apartment",
  LAND = "land",
  WHOLE_BUILDING = "whole-building",
  OFFICE = "office",
  WAREHOUSE = "warehouse",
  RETAIL = "retail",
  STAFF_ACCOMMODATION = "staff-accommodation",
  COMMERCIAL = "commercial",
  SHOP = "shop",
  SHOWROOM = "showroom",
  LABOR_CAMP = "labor-camp",
  FULL_FLOOR = "full-floor",
  UNKNOWN = "unknown",
}

export enum PropertyBedroomType {
  STUDIO = "studio",
  ONE = "1",
  TWO = "2",
  THREE = "3",
  FOUR = "4",
  FIVE_PLUS = "5+",
}

export enum PropertyBathroomType {
  ONE = "1",
  TWO = "2",
  THREE = "3",
  FOUR = "4",
  FIVE_PLUS = "5+",
}

export enum PropertyCompletionStatusType {
  OFF_PLAN = "off-plan",
  READY = "ready",
  UNKNOWN = "unknown",
}

// TODO: are you sure the back-end accept those ?
export enum PropertyAmenity {
  BEACHFRONT = "beachfront",
  GOLF_VIEW = "golf-view",
  LANDMARK_VIEW = "landmark-view",
  PETS_ALLOWED = "pets-allowed",
  PRIVATE_GARDEN = "private-garden",
  PRIVATE_GYM = "private-gym",
  PRIVATE_JACUZZI = "private-jacuzzi",
  PRIVATE_POOL = "private-pool",
  SHARED_GYM = "shared-gym",
  SHARED_POOL = "shared-pool",
  WATERFRONT_VIEW = "waterfront-view",
  WINE_CELLAR = "wine-cellar",
  MAIDS_ROOM = "maids-room",
  STUDY = "study",
  CENTRAL_AIR_CONDITIONING = "central-air-conditioning",
  BALCONY = "balcony",
  SECURITY = "security",
  BUILT_IN_WARDROBES = "built-in-wardrobes",
  WALK_IN_CLOSET = "walk-in-closet",
  KITCHEN_APPLIANCES = "kitchen-appliances",
  VIEW_OF_LANDMARK = "view-of-landmark",
  SHARED_SPA = "shared-spa",
  GATED_COMMUNITY = "gated-community",
  CONFERENCE_ROOM = "conference-room",
  BBQ_AREA = "bbq-area",
  SOUTH_ORIENTATION = "south-orientation",
  WOOD_FLOORING = "wood-flooring",
  NEAR_PUBLIC_TRANSPORTATION = "near-public-transportation",
  INDOOR_SWIMMING_POOL = "indoor-swimming-pool",
  JACUZZI = "jacuzzi",
  MAID_SERVICE = "maid-service",
  NEAR_SUPERMARKET = "near-supermarket",
  NEAR_SCHOOL = "near-school",
  EAST_ORIENTATION = "east-orientation",
  LAUNDRY_ROOM = "laundry-room",
  PRIVATE_GARAGE = "private-garage",
  STEAM_ROOM = "steam-room",
  FULLY_FITTED_KITCHEN = "fully-fitted-kitchen",
  BASEMENT_PARKING = "basement-parking",
  MAINTENANCE = "maintenance",
  NEAR_GOLF = "near-golf",
  SEA_WATER_VIEW = "seawater-view",
  ON_MID_FLOOR = "on-mid-floor",
  PUBLIC_PARKS = "public-parks",
  CORE_AND_SHELL = "core-and-shell",
  EQUESTRIAN = "equestrian",
  GARDEN_VIEW = "garden-view",
  NEAR_VETERINARY = "near-veterinary",
  HEATING = "heating",
  BEACH_ACCESS = "beach-access",
  NEAR_AIRPORT = "near-airport",
  NEAR_MALL = "near-mall",
  CHILDREN_POOL = "childrens-pool",
  CHILDREN_PLAY_AREA = "childrens-play-area",
  NEAR_RESTAURANTS = "near-restaurants",
  NEAR_METRO = "near-metro",
  NEAR_MOSQUE = "near-mosque",
  BASEMENT = "basement",
  NEAR_HOSPITAL = "near-hospital",
  COMMUNITY_VIEW = "community-view",
  PANTRY = "pantry",
  LAKE_VIEW = "lake-view",
  UPGRADED_INTERIOR = "upgraded-interior",
  WEST_ORIENTATION = "west-orientation",
  WITHIN_A_COMPOUND = "within-a-compound",
  CABLE_READY = "cable-ready",
  CITY_VIEW = "city-view",
  SAUNA = "sauna",
  ON_HIGH_FLOOR = "on-high-floor",
  STORAGE_ROOM = "storage-room",
  MARBLE_FLOORS = "marble-floors",
  LOBBY = "lobby",
  VASTU_COMPLIANT = "vastu-compliant",
  NEAR_HOTEL = "near-hotel",
  DRIVERS_ROOM = "drivers-room",
  TERRACE = "terrace",
  COVERED_PARKING = "covered-parking",
  CONCIERGE_SERVICE = "concierge-service",
  CARPETS = "carpets",
  CLEANING_SERVICES = "cleaning-services",
  OFFICE_PARTITIONS = "office-partitions",
  VISITORS_PARKING = "visitors-parking",
  GAZEBO = "gazebo",
  ON_LOW_FLOOR = "on-low-floor",
  RECEPTION_AREA = "reception-area",
  NORTH_ORIENTATION = "north-orientation",
  CHILDREN_DAYCARE = "children-daycare",
  SERVER_ROOM = "server-room",
  GROUND_FLOOR = "ground-floor",
}

export enum PropertySorting {
  FEATURED = "featured",
  DATE_NEW_TO_OLD = "date:desc",
  DATE_OLD_TO_NEW = "date:asc",
  PRICE_HIGH_TO_LOW = "price:desc",
  PRICE_LOW_TO_HIGH = "price:asc",
  AREA_LOW_TO_HIGH = "area:desc",
  AREA_HIGH_TO_LOW = "area:asc",
}

export enum PropertyListingViewType {
  LIST = "list",
  MAP = "map",
}

export enum PropertyBadgeType {
  YALLA_VALUE_VERIFIED = "yalla-value-verified",
  HOT_DEAL = "hot_deal",
}
